const PROPERTY_OPPORTUNITIES_NAMES = {
    BY_CURRENT_ANNUAL_PROFIT: 'Mejor rendimiento',
    BY_LOWEST_PRICE: 'Ticket más bajo',
    BY_ESTIMATED_ANNUAL_PROFIT: 'En crecimiento',
    BY_CURRENT_CAP_RATE: 'Mayor renta'
};
export default PROPERTY_OPPORTUNITIES_NAMES;
